import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-link.tsx
/**
* icon.16.link
*
* Keywords: chain, link-connection, hyperlink, connect, diagonal, url, attachment, relationship
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTguMzggNi4zODFhLjI5LjI5IDAgMCAxIC4zNDctLjA1NnEuMjkzLjE2MS41NDEuNDA4YTIuNSAyLjUgMCAwIDEgMCAzLjUzNWwtMiAyYTIuNSAyLjUgMCAwIDEtMy41MzUtMy41MzVsLjU3MS0uNTczYy4yNS0uMjQ5LjY5Mi0uMTA3LjgxLjIyNGEuNDYuNDYgMCAwIDEtLjA5OC40NzhsLS41NzYuNTc4YTEuNSAxLjUgMCAxIDAgMi4xMjEgMi4xMmwyLTJhMS41IDEuNSAwIDAgMCAwLTIuMTJjLS4yMy0uMjMtLjQ5My0uNTA5LS4zNTgtLjgwNWEuOS45IDAgMCAxIC4xNzgtLjI1NG0uMzUyLTIuNjQ4YTIuNSAyLjUgMCAxIDEgMy41MzUgMy41MzVsLS40NzEuNDdjLS4yNTMuMjU0LS43MTcuMDgyLS44MTktLjI2MWEuNDQuNDQgMCAwIDEgLjEwMi0uNDM1bC40ODEtLjQ4MUExLjUgMS41IDAgMCAwIDkuNDQgNC40NGwtMiAyYTEuNSAxLjUgMCAwIDAgMCAyLjEyYy4xMzYuMTM4LjE2OC4zNjUuMDMxLjUwMmwtLjE4Mi4xODFjLS4xNTQuMTU0LS40MDMuMTc5LS41NTcuMDI1YTIuNSAyLjUgMCAwIDEgMC0zLjUzNXoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-11963
*/
const Icon16Link = memo(function Icon16Link(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M8.38 6.381a.29.29 0 0 1 .347-.056q.293.161.541.408a2.5 2.5 0 0 1 0 3.535l-2 2a2.5 2.5 0 0 1-3.535-3.535l.571-.573c.25-.249.692-.107.81.224a.46.46 0 0 1-.098.478l-.576.578a1.5 1.5 0 1 0 2.121 2.12l2-2a1.5 1.5 0 0 0 0-2.12c-.23-.23-.493-.509-.358-.805a.9.9 0 0 1 .178-.254m.352-2.648a2.5 2.5 0 1 1 3.535 3.535l-.471.47c-.253.254-.717.082-.819-.261a.44.44 0 0 1 .102-.435l.481-.481A1.5 1.5 0 0 0 9.44 4.44l-2 2a1.5 1.5 0 0 0 0 2.12c.136.138.168.365.031.502l-.182.181c-.154.154-.403.179-.557.025a2.5 2.5 0 0 1 0-3.535z"
		})
	});
});
//#endregion
export { Icon16Link };

//# sourceMappingURL=icon-16-link.js.map